import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import state from '../state'
gsap.registerPlugin(ScrollTrigger)

class Video {
  constructor (el) {
    this.el = el
    this.offset = 700
    this.setupPlaceholder()
  }

  setupPlaceholder () {
    if (this.el.videoWidth && this.el.videoHeight) {
      this.applyAspectRatio()
    } else {
      this.el.addEventListener('loadedmetadata', () => {
        this.applyAspectRatio()
        if (state.smoothScroll && state.smoothScroll.lenis) {
          state.smoothScroll.lenis.resize()
        }
        ScrollTrigger.refresh()
      })
    }
  }

  applyAspectRatio () {
    const naturalWidth = this.el.videoWidth
    const naturalHeight = this.el.videoHeight

    if (naturalWidth && naturalHeight) {
      const wrapper = this.el.closest('.c-media-wrapper')

      if (wrapper) {
        const aspectRatio = naturalHeight / naturalWidth
        wrapper.style.position = 'relative'
        wrapper.style.width = '100%'
        wrapper.style.paddingTop = `${aspectRatio * 100}%`

        this.el.style.position = 'absolute'
        this.el.style.top = '0'
        this.el.style.left = '0'
        this.el.style.width = '100%'
        this.el.style.height = '100%'
      }
    }
  }

  init () {
    if (this.el.dataset.src && !this.el.dataset.finalSrc) {
      this.el.dataset.finalSrc = this.el.dataset.src
    }

    this.lazyLoadWithGsap()
  }

  lazyLoadWithGsap () {
    gsap.registerPlugin(ScrollTrigger)

    ScrollTrigger.create({
      trigger: this.el,
      start: `top bottom+=${this.offset}`,
      onEnter: () => {
        this.loadVideo()
      },
      once: true,
    })
  }

  loadVideo () {
    this.el.src = this.el.dataset.finalSrc || this.el.dataset.src
    this.el.removeAttribute('data-src')
    this.el.removeAttribute('data-final-src')
  }
}

export default Video



//////////////////
// WEBPACK FOOTER
// ./scripts/components/Video.js
// module id = 71
// module chunks = 0